import React from 'react';
import { useTranslation } from 'react-i18next';

/** Names the archived repositories a card left out, so a client can see what its numbers cover. */
export const ArchivedNote = ({ repositories }: { repositories?: string[] }): JSX.Element | null => {
  const { t } = useTranslation();
  if (!repositories?.length) return null;

  return (
    <p className="mt-2 text-xs text-muted-foreground">
      {t('productDashboard.archivedNotCounted', { count: repositories.length, repositories: repositories.join(', ') })}
    </p>
  );
};
